<template>
  <div>
    <el-input class="search-el" size="mini" v-model="query.mobile" placeholder="手机号/姓名"></el-input>
    <el-input class="search-el" size="mini" v-model="query.title" placeholder="请输入标题"></el-input>
    <!-- <el-select class="search-el" size="small" v-model="query.status" placeholder="活动状态">
      <el-option label="全部活动" value="">全部活动</el-option>
      <el-option label="上线" value="1">上线</el-option>
      <el-option label="下线" value="0">下线</el-option>
    </el-select> -->

    <el-select class="search-el" size="small" v-model="query.meet_type" placeholder="请选择类型">
      <el-option label="请选择类型" value="">请选择类型</el-option>
      <el-option label="心理公开课" value="1">心理公开课</el-option>
      <el-option label="幸福之旅" value="2">幸福之旅</el-option>
      <el-option label="发光者活动" value="3">发光者活动</el-option>
    </el-select>
    <el-button type="primary" size="mini" @click="getList()">
      查询
    </el-button>
    <el-button type="primary" size="mini" @click="toCreate()">
      添加
    </el-button>
    <el-button type="warning" size="mini" @click="toInviteInfo(432)">
      遇见心理公开课开课通知
    </el-button>
    <el-button type="warning" size="mini" @click="toInviteInfo(433)">
      发光者开课通知
    </el-button>

    <el-row>
      <el-table
          v-loading="loading"
          :data="list"
          border
          size="mini"
          :stripe="true"
          style="width: 100%; margin: 20px 0"
      >
        <el-table-column
            prop="id"
            label="ID"
            align="center"
        ></el-table-column>

        <el-table-column
            label="标题"
            align="center"
        >
          <template slot-scope="{ row }">
            <el-button type="text" size="small" @click="toCreate(row.id)">
              <div>{{ row.name }}</div>
            </el-button>
          </template>
        </el-table-column>
        <el-table-column
            prop="start_at"
            label="开始时间"
            align="center"
        ></el-table-column>
        <el-table-column
            prop="meet_type_value"
            label="类型"
            align="center"
        ></el-table-column>
        <el-table-column
            prop="end_at"
            label="结束时间"
            align="center"
        ></el-table-column>

        <el-table-column
            prop="created_at"
            label="创建时间"
            align="center"
        ></el-table-column>

        <el-table-column label="查看" align="center" width="480" fixed="right">
          <template slot-scope="{ row }">
            <el-button type="primary" size="mini" @click="activityCourse(row.id, 3)">课程</el-button>
            <el-button type="primary" size="mini" @click="toLodgingItem(row.id)">餐食</el-button>
            <el-button type="primary" size="mini" @click="activityObject(row.id)">小组</el-button>
            <el-button type="primary" size="mini" @click="row.meet_type == 2 ? activityObjectRelationXf(row.id) : activityObjectRelation(row.id) ">学员</el-button>
            <el-button type="primary" size="mini" @click="meetActivityQrcode(row.id)">签到二维码</el-button>
            <el-button type="primary" size="mini" @click="meetOrder(row.id)">订单</el-button>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" width="150" fixed="right">
          <template slot-scope="{ row }">
            <el-button size="mini" type="text" @click="row.status == 1 ? meetActivitySet(row.id, 0) : meetActivitySet(row.id, 1)">
              {{ row.status == 1 ? '下架' : '发布' }}
            </el-button>
            <el-button type="danger" icon="el-icon-delete" size="mini" @click="deleteActivity(row.id)"></el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-row>
    <el-row>
      <div class="block">
        <el-pagination
            background
            @current-change="getList"
            :current-page.sync="query.page"
            :page-size="query.limit"
            layout="total, prev, pager, next, jumper"
            :total="total"
        >
        </el-pagination>
      </div>
    </el-row>

    <!-- 二维码弹窗 -->
    <el-dialog
        title="遇见签到二维码"
        :visible.sync="dialogVisible"
        width="50%"
    >
      <div id="qrcode" style="margin:0 auto; width: 600px"></div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogVisible = false"
        >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {qrCode} from "@/api/common";
import {getMeetActivityList, deleteActivity, meetActivitySet, meetActivityQrcode} from "@/api/activity";

export default {
  data: function () {
    return {
      dialogVisible: false,
      list: [],
      loading: false,
      total: 0,
      query: {
        page: 1,
        limit: 20,
        title: "",
        mobile: "",
        status: "",
        meet_type: "",
      },
    };
  },
  created: function () {
    this.getList();
  },
  methods: {
    toInviteInfo(id) {
      this.$router.push({
        path: "/activity/inviteInfo",
        query: {
          id: id,
        }
      });
    },
    toLodgingItem(id) {
      this.$router.push({
        path: "/activity/meetLodgingItem",
        query: {
          id: id,
        }
      });
    },
    toCreate(id = 0) {
      this.$router.push({
        path: "/activity/meetAdd",
        query: {
          id: id,
        }
      });
    },
    activityCourse(id, type) {
      this.$router.push({
        path: '/activity/meetCourse',
        query: {
          activity_id: id,
          type: type,
        }
      })
    },
    meetOrder(id) {
      this.$router.push({
        path: '/activity/meetOrder',
        query: {
          activity_id: id,
        }
      })
    },
    activityObject(id) {
      this.$router.push({
        path: "/activity/meetObjectList",
        query: {
          activity_id: id,
        }
      });
    },
    activityObjectRelation(id) {
      this.$router.push({
        path: "/activity/meetObjectRelation",
        query: {
          activity_id: id,
        }
      });
    },
    //幸福之旅学员列表
    activityObjectRelationXf(id) {
      this.$router.push({
        path: "/activity/meetObjectRelationXf",
        query: {
          activity_id: id,
        }
      });
    },

    getList(str) {
      this.loading = true;
      getMeetActivityList(this.query).then((response) => {
        this.list = response.data.list;
        this.total = response.data.total;
        this.loading = false;
      });
    },

    deleteActivity(id) {
      this.$confirm("确定执行删除吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        deleteActivity({
          id: id,
        }).then((response) => {
          if (response.status == 2000) {
            this.getList();
            this.$message({
              showClose: true,
              message: "删除成功",
              type: "success",
            });
          } else {
            this.$message({
              showClose: true,
              message: response.message,
              type: "error",
            });
          }
        });
      });
    },

    meetActivitySet(id, type) {
      meetActivitySet({
        id: id,
        status: type,
      }).then((response) => {
        if (response.status == 2000) {
          this.getList();
          this.$message({
            showClose: true,
            message: "设置成功",
            type: "success",
          });
        } else {
          this.$message({
            showClose: true,
            message: response.message,
            type: "error",
          });
        }
      });
    },

    meetActivityQrcode(id) {
      meetActivityQrcode({
        activity_id: id,
      }).then((response) => {
        if (response.status == 2000) {
          this.dialogVisible = true;
          this.$nextTick(function () {
            document.getElementById("qrcode").innerHTML = "";
            let qrcode = qrCode(response.data.qrcode);
          });
        } else {
          this.$message({
            showClose: true,
            message: response.message,
            type: "error",
          });
        }
      });
    },
  },
  mounted() {
  },
};
</script>